<template>
    <div class="wrapper">
        <v-navigation-drawer
            color="green lighten-5"
            v-model="drawerRight"
            :width="500"
            app
            clipped
            right
        >
            <halaman-order></halaman-order>
        </v-navigation-drawer>

        <v-app-bar
            app
            clipped-left
            clipped-right
            color="teal darken-4 white--text"
        >
            <v-app-bar-nav-icon color="white" @click="drawer = !drawer" />
            <span class="title ml-3 mr-5">Semanggi&nbsp;<span class="font-weight-light">POS</span></span>
            <v-spacer />
            <v-badge
                color="red"
                :content="numberOfList == 0 ? '0' : numberOfList"
                class="mr-3 mt-3"
            >
                <v-icon color="white" @click.stop="drawerRight = !drawerRight">shopping_cart</v-icon>
            </v-badge>
        </v-app-bar>

        <v-navigation-drawer
            v-model="drawer"
            app
            clipped
            color="green lighten-5"
        >

            <div
                class="pa-2"
                width="100%"
            >
                <v-avatar v-if="imgProfile != null" style="cursor: pointer" color="teal darken-4" size="42" @click="logout()">
                    <img
                        :src="imgProfile"
                        alt="Logo"
                    >
                </v-avatar>
                <v-avatar v-else style="cursor: pointer" color="teal darken-4" size="42" @click="logout()">
                    <v-icon dark>mdi-account-circle</v-icon>
                </v-avatar>
                <span class="ml-4 font-weight-black subtitle-2">
                    Petugas: {{userLogin.name}}
                </span>
            </div>
            <v-divider />
            <v-list dense>
                <v-list-item v-if="userRole == 'cashier'" link :to="'/dashboard'">
                    <v-list-item-icon>
                        <v-icon>home</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Dashboard</v-list-item-title>
                </v-list-item>

                <!-- <v-list-group
                    prepend-icon="category"
                    v-if="userRole == 'cashier'"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Jasa & Layanan</v-list-item-title>
                    </template>

                    <v-list-item
                        v-for="(admin, i) in admins"
                        :key="i"
                        link
                        :to="admin[2]"
                    >
                        <v-list-item-title v-text="admin[0]"></v-list-item-title>
                        <v-list-item-icon>
                        <v-icon v-text="admin[1]"></v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                </v-list-group> -->
                <!-- <v-list-item link :to="'/daftar-barang'">
                    <v-list-item-icon>
                        <v-icon>shopping_basket</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Daftar Barang</v-list-item-title>
                </v-list-item>
                <v-list-item link :to="'/daftar-layanan'">
                    <v-list-item-icon>
                        <v-icon>build</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Daftar Layanan</v-list-item-title>
                </v-list-item> -->
                <v-list-item link :to="'/order-jasa'">
                    <v-list-item-icon>
                        <v-icon>event</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Jadwal Layanan</v-list-item-title>
                </v-list-item>
                <v-list-item link :to="'/checkIn'">
                    <v-list-item-icon>
                        <v-icon>list_alt</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Check In</v-list-item-title>
                </v-list-item>
                <v-list-item link :to="'/daftar-hadir'">
                    <v-list-item-icon>
                        <v-icon>ballot</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Daftar Hadir</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item link :to="'/orders'">
                    <v-list-item-icon>
                        <v-icon>list_alt</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Riwayat Order</v-list-item-title>
                </v-list-item>
                <v-list-item link :to="'/riwayat-produk'">
                    <v-list-item-icon>
                        <v-icon>ballot</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Riwayat Produk</v-list-item-title>
                </v-list-item> -->
            </v-list>
            <!-- <template v-slot:append>
                <div class="pa-2">
                    <v-btn block color="teal darken-3 white--text" @click="logout()">Logout</v-btn>
                </div>
            </template> -->
        </v-navigation-drawer>

        <div class="main-panel">
            <!-- <top-navbar></top-navbar> -->

            <dashboard-content></dashboard-content>
            <dialog-order></dialog-order>
            <dialog-login></dialog-login>
            <dialog-regis></dialog-regis>

            <!-- <content-footer v-if="!$route.meta.hideFooter"></content-footer> -->

            <v-snackbar style="z-index: 9999"
                :top='true'
                v-model='snackbar.visible'
                :color='snackbar.color'
                :timeout='snackbar.timeout'
                :multi-line='snackbar.multiline'
            >{{snackbar.text}}</v-snackbar>
            <v-overlay :value="loading.visible">
                <v-progress-circular :color='loading.color' indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { forEach, isEmpty, remove, find } from "lodash";
import DashboardContent from "./Content.vue";
import HalamanOrder from "@/components/HalamanOrder.vue";
import DialogOrder from "@/components/DialogOrder.vue";
import DialogLogin from "@/components/DialogLogin.vue";
import DialogRegis from "@/components/DialogRegis.vue";
export default {
    components: {
        HalamanOrder,
        DashboardContent,
        DialogOrder,
        DialogLogin,
        DialogRegis
    },
    data: () => ({
        drawer: false,
        drawerRight: false,
        userRole: null,
        admins: [
            ['Jadwal Jasa', 'event', '/order-jasa'],
            ['Manage Jasa', 'settings'],
        ],
        cruds: [
            ['Create', 'add'],
            ['Read', 'insert_drive_file'],
            ['Update', 'update'],
            ['Delete', 'delete'],
        ],
        imgProfile: null
    }),
    computed:{
        ...mapState({
            snackbar: state => state.snackbar,
            loading: state => state.loading,
            numberOfList: state => state.products.numberOfList
        })
    },
    created(){
        this.userLogin = JSON.parse(window.localStorage.getItem('user_data'))
        this.userRole = window.localStorage.getItem('user_role')
        const attachments = JSON.parse(window.localStorage.getItem('user_attachment'))
        if(attachments.length > 0){
            forEach(attachments, attachment => {
                if(attachment.attachment_type == 'PROFIL'){
                    this.imgProfile = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + attachment.location + '/' + attachment.name
                }
            })
        }
    },
    methods: {
        ...mapActions({
            logOut: "auth/logOut"
        }),
        logout() {
            let result = confirm("Are you sure you want to logout?");
            if(result){
                this.logOut()      
            }
        },
    }
}
</script>